import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/use-auth-store";
import { LoginModal } from "./login-modal";
import { useState, useEffect } from "react";

export default function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuthStore();
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      setShowLogin(true);
    } else {
      setShowLogin(false);
    }
  }, [isAuthenticated, loading]);

  const handleOpenChange = (open: boolean) => {
    if (!open && !isAuthenticated) {
      // If user closes modal without logging in, redirect to home
      navigate("/");
    }
    setShowLogin(open);
  };

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return (
      <>
        <LoginModal open={showLogin} onOpenChange={handleOpenChange} />
        {/* We don't render Outlet here to protect the content */}
      </>
    );
  }

  return <Outlet />;
}
